import { call, put, takeLatest } from "redux-saga/effects";
import { userApi } from "../../../api/user/userApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { eUserActionTypeIds, IUserActionTypes } from "../../action-types/user/IUserActionTypes";
import { actions } from "../../actions";
import { IUserViewModel } from "../../../model/respone/user/IUserViewModel";
const mainAction = actions.user;
export function* userSaga(): any {
    yield takeLatest(eUserActionTypeIds.LOAD_START, loadUserWorker)
    yield takeLatest(eUserActionTypeIds.SAVE_START, saveWorker)
    yield takeLatest(eUserActionTypeIds.DELETE_START, deleteWorker)
}
function* loadUserWorker(action: IUserActionTypes): any {
    const res: IBaseRespone = yield call(userApi.selectAll)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data))
    } else {
        yield put(mainAction.LOAD_ERRR(res.message ?? "Có lỗi"))
    }
}
function* saveWorker(action: IUserActionTypes): any {
    const payload = action.payload as IUserViewModel;
    let res: IBaseRespone;
    if (payload.id > 0) {
        res = yield call(userApi.update, payload);
    } else {
        res = yield call(userApi.update, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(res.data));
    } else {
        yield put(mainAction.SAVE_ERRR(res.message ?? "Có lỗi"));
    }
}

function* deleteWorker(action: IUserActionTypes): any {
    const res: IBaseRespone = yield call(userApi.delete, action.payload as number);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(res.data));
    } else {
        yield put(mainAction.DELETE_ERRR(res.message ?? "Có lỗi"));
    }
}